/**
 * created by xcc
 * 阵地维护
 */
import React from "react";
import {Button, Input, Modal, Upload, Popconfirm, Select, Icon} from "antd";
import {message} from "../../../../../utils/message";
import "./MaintenanceField.css";
import addImg from "./images/add.png";
import {setInfoToLocalStorage} from "../../../../../actions";
import BaseComponent from "../../../../../base/BaseComponent";
import Scrollbars from 'react-custom-scrollbars';
import CmForm from "../../../../../components/CmForm/CmForm";
import PageTemplate from "../../../components/pageTemplate/PageTemplate";
import TableTemplate from "../../../components/TableTemplate/TableTemplate";
import {generateColumns, getMaxWidth} from "../../../../newMediaMatrix/components/utils";
import PaginationTemplate from "../../../components/PaginationTemplate/PaginationTemplate";
import { DndProvider, DragSource, DropTarget} from 'react-dnd';
import  HTML5Backend from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import UploadWall from "../../../../../components/upload/UploadWall";
import FieldsTable from "./components/fieldsTable";

const {Option} = Select;

let dragingIndex = -1;

class BodyRow extends React.Component {
    render() {
        const { isOver, connectDragSource, connectDropTarget, moveRow, ...restProps } = this.props;
        const style = { ...restProps.style, cursor: 'move' };

        let { className } = restProps;
        if (isOver) {
            if (restProps.index > dragingIndex) {
                className += ' drop-over-downward';
            }
            if (restProps.index < dragingIndex) {
                className += ' drop-over-upward';
            }
        }

        return connectDragSource(
            connectDropTarget(<tr {...restProps} className={className} style={style} />),
        );
    }
}

const rowTarget = {
    drop(props, monitor) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;

        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }

        // Time to actually perform the action
        props.moveRow(dragIndex, hoverIndex);

        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    },
}

const rowSource = {
    beginDrag(props) {
        dragingIndex = props.index;
        return {
            index: props.index,
        };
    },
};

const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
}))(
    DragSource('row', rowSource, connect => ({
        connectDragSource: connect.dragSource(),
    }))(BodyRow),
);

export default class PositionMaintenance extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            dataSource: [],
            pageNum: 1,
            pageSize: 10,
            count: 0,
            addVisible: false,
            modalTitle: "",
            editingMediaId: "",
            name: "",
            logo: "",
            divisionName: "线上平台",
            contentEntry: 0,
            copyVisible:false,//复用阵地的弹框
            positionTypeList:[],
            currentType:'',
            disposeLink: "",
            differentRecordOnline: false,
            positionRecordOnline: null
        };
    }

    componentDidMount() {
        this.getList();
        this.getSystemSetting();
    }

    componentWillUnmount() {

    }

    getColumns() {
        const baseColumns = [
            {
                title: "平台名称",
                dataIndex: "name",
                key: "name",
                width: 200,
                ellipsis: true
            },
            {
                title: "平台logo",
                dataIndex: "logo",
                key: "logo",
                width: 100,
                render: (text, record) => {
                    return (
                        <>
                            {/*此logo是通过后台配置项而来*/}
                            <img alt={"账号logo"} src={record.logo}
                                 style={{
                                     width: 25,
                                     height: 25,
                                     borderRadius: "50%",
                                     objectFit: "cover"
                                 }}/>
                        </>
                    );
                }
            },
            {
                title: "是否内置",
                dataIndex: "builtIn",
                key: "builtIn",
                width: 100,
                ellipsis: true,
                render: text => (text ? "是" : "否")
            },
            {
                title: "平台划分",
                dataIndex: "divisionName",
                key: "divisionName",
                ellipsis: true,
                width: 100,
            },
            {
                title: "内容录入",
                dataIndex: "contentEntry",
                key: "contentEntry",
                width: 100,
                ellipsis: true,
                render: text => (text ? "是" : "否")
            },
            {
                title: "添加人",
                dataIndex: "createUser",
                key: "createUser",
                ellipsis: true,
                width: 150,
            },
            {
                title: "操作",
                dataIndex: "operation",
                key: "operation",
                width: 340,
                render: (text, record) => {
                    return (
                        <>
                                <span style={{color: "#0050B3", marginRight: 10, cursor: "pointer"}}
                                      onClick={() => this.editPlatform(record)}>编辑</span>
                            <span style={{color: "#0050B3", cursor: "pointer", marginRight: 10}}
                                  onClick={() => this.maintenanceField(record)}>维护字段</span>
                            <span style={{color: "#0050B3", cursor: "pointer", marginRight: 10}}
                                  onClick={() => this.copyPosition(record)}>复用其他平台</span>
                            {this.state.differentRecordOnline && <span style={{color: "#0050B3", cursor: "pointer", marginRight: 10}}
                                   onClick={() => this.viewFieldTable(record)}>查看字段表</span>}
                            <Popconfirm
                                title={`确定删除平台：${record.name}`}
                                onConfirm={() => this.delete(record)}
                                okText="确定"
                                cancelText="取消"
                            >
                                {
                                    record.builtIn ?
                                        "" : <span style={{color: "red", cursor: "pointer"}}>删除</span>
                                }
                            </Popconfirm>
                        </>
                    );
                }
            }
        ]
        const dynamicColumns = [
            {
                key: 'positionRecordOnline',
                dataIndex: "positionRecordOnline",
                title: '电子备案表模板',
                width: 200,
                checkFunction: () => {
                    return this.state.differentRecordOnline;
                },
                position: 5,
                render: (text, record) => {
                    let name = record?.positionRecordOnline?.name && record.positionRecordOnline.name.split(".").at(0);
                    return <div style={{display: "flex", alignItems: "bottom", color: "#008dff", cursor: "pointer"}} onClick={() => {
                        this.downTemplate(record.positionRecordOnline)
                    }}>
                        <div title={name} style={{
                            maxWidth: 140,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            display: "inline-block"
                        }}>
                            {name}
                        </div>
                        {name && <div>.{record?.positionRecordOnline?.ext}</div>}
                    </div>;
                }
            }
        ];
        return generateColumns(baseColumns, dynamicColumns)
    }

    /**
     * 当页码变换的回调
     * @param page
     * @param pageSize
     */
    onPageChange = ({current, pageSize}) => {
        this.setState({
            pageNum: current,
            pageSize: pageSize
        }, () => {
            this.getList();
        });
    };

    /**
     * pageSize 变化的回调
     * @param current
     * @param size
     */
    onShowSizeChange = ({current, pageSize}) => {
        this.setState({
            pageSize: pageSize,
            pageNum: 1
        }, () => {
            this.getList();
        });
    };

    /**
     * 渲染添加modal
     */
    renderAdd() {
        const {logo, name, editingMediaId, modalTitle, addVisible, disposeLink, positionRecordOnline} = this.state;
        const uploadButton = (
            <div>
                <img style={{width: 100, height: 100, objectFit: "cover"}} src={addImg} alt={""}/>
            </div>
        );
        const platformDivideShow = this.sysConfigGetValueByKey("position.platform.divide.screen", "no") === "no";
        return (
            <Modal
                title={modalTitle}
                width={400}
                visible={addVisible}
                onOk={() => this.handleOk(editingMediaId)}
                okText={"保存"}
                onCancel={() => this.setState({addVisible: false, editingMediaId: ""})}
                centered={true}
                maskClosable={false}
            >
                <CmForm onSubmit={() => {
                    this.handleOk(editingMediaId)
                }}>
                    <div className="edit_wrap">
                        <div className="upload_wrap">
                            <Upload
                                name="file"
                                listType="picture-card"
                                className="avatar-uploader"
                                multiple={false}
                                showUploadList={false}
                                beforeUpload={beforeUpload}
                                customRequest={({file}) => {
                                    let url = "/storage/uploadFile";
                                    let fd = new FormData();
                                    fd.append("file", file);
                                    this.request({
                                        url,
                                        body: fd,
                                        method: "post",
                                        contentType: "upload",
                                        callBack: (file) => {
                                            let that = this;
                                            if (file) {
                                                let logo = file.path ? file.path : null;
                                                that.setState({
                                                    logo
                                                })
                                            }
                                        },
                                        errorCallBack: () => {

                                        },
                                        serverVerify: {
                                            serverErrorCallBack: () => {

                                            }
                                        }
                                    });
                                }}
                            >
                                {
                                    logo ?
                                        <img src={logo} alt="avatar"
                                             style={{
                                                 width: "100px",
                                                 height: "100px",
                                                 objectFit: "cover",
                                                 borderRadius: "50%"
                                             }}/> :
                                        uploadButton
                                }
                            </Upload>
                        </div>
                        <div className="name_wrap">
                            <div><span style={{color: "red"}}>*</span> 平台名称：</div>
                            <Input type="text" value={name} placeholder={"请输入"}
                                   onChange={e => this.setState({name: e.target.value})}/>
                        </div>
                        {this.state.builtIn ? null : platformDivideShow ? null :
                            <div className="name_wrap">
                                <div><span style={{color: "red"}}>*</span> 平台划分：</div>
                                <div style={{width: 120}}>
                                    <Select placeholder={"请选择"}
                                            value={this.state.divisionName}
                                            style={{width: '120px'}}
                                            onChange={(value) => {
                                                this.state.divisionName = value;
                                                this.setState({})
                                            }}>
                                        <Option value={"线上平台"} key={"线上平台"}>线上平台</Option>
                                        <Option value={"线下平台"} key={"线下平台"}>线下平台</Option>
                                    </Select>
                                </div>
                            </div>}
                        {this.state.builtIn ? null :
                            <div className="name_wrap">
                                <div><span style={{color: "red"}}>*</span> 内容录入：</div>
                                <div style={{width: 120}}>
                                    <Select placeholder={"请选择"}
                                            value={this.state.contentEntry}
                                            style={{width: '120px'}}
                                            onChange={(value) => {
                                                this.state.contentEntry = value;
                                                this.setState({})
                                            }}>
                                        <Option value={1} key={"是"}>是</Option>
                                        <Option value={0} key={"否"}>否</Option>
                                    </Select>
                                </div>
                            </div>}
                        {this.state.builtIn && editingMediaId && <div className="name_wrap">
                            <div>&nbsp; 处理地址：</div>
                            <Input type="text" value={disposeLink} placeholder={"请输入"}
                                   onChange={e => this.setState({disposeLink: e.target.value})}/>
                        </div>}
                        {this.state.differentRecordOnline && <div className="name_wrap" style={{alignItems: "baseline"}}>
                            <div>&nbsp; 备案表模板：</div>
                            <UploadWall
                                action="/storage/uploadFile"
                                uploadBtnName={<>
                                    <Button><Icon type="upload"/>点击上传</Button>
                                    <span onClick={(e) => {
                                        e.stopPropagation()
                                    }}>
                                            <span style={{
                                                color: "#00000072",
                                                fontSize: "14px",
                                                marginLeft: "10px",
                                                verticalAlign: "bottom"
                                            }}>支持扩展名：{this.electricFileType.map(item => "." + item).join(" ")}</span>
                                        </span>
                                </>}
                                showUploadBtn={true}
                                listType="list"
                                fileList={positionRecordOnline && Object.keys(positionRecordOnline).length > 0 ? [positionRecordOnline] : []}
                                icons={["download", "delete"]}
                                beforeUpload={(file) => {
                                    const upperCaseType = this.electricFileType?.map(item => item.toUpperCase())
                                    const finalType = [...this.electricFileType, ...upperCaseType];
                                    const typeResult = finalType.some(item => file.name.endsWith(item));
                                    if (!typeResult) {
                                        message.warning("文件格式错误");
                                        return Promise.reject();
                                    }
                                    return Promise.resolve(file);
                                }}
                                accept={this.electricFileType.map(item => "." + item).join(",")}
                                onChange={({file}) => {
                                    let temp = {
                                        ...file,
                                        response: {
                                            ...file.response?.data, ...file.response,
                                            data: file.response?.data
                                        },
                                        ext: file.response?.data ? file.response.data.suffix : file.response?.suffix,
                                        url: file.response?.data ? file.response.data.path : file.response?.path,
                                        path: file.response?.data ? file.response.data.path : file.response?.path,
                                        name: file.response?.data ? file.response.data.name : file.response?.name,
                                        md5: file.response?.data ? file.response.data.md5 : file.response?.md5,
                                        _id: file.response?.data ? file.response.data._id : file.response?._id,
                                    };
                                    if (file.status === 'done') {
                                        this.setState({
                                            positionRecordOnline: temp
                                        })
                                    }
                                }}
                                onDownload={() => {
                                    this.downTemplate(this.state.positionRecordOnline)
                                }}
                                onSuccess={(response, file) => {
                                    let temp = {};
                                    if (response.status === 200) {
                                        temp = {
                                            ...file,
                                            response: {...response?.data, ...response, data: file.response?.data},
                                            ext: response?.data ? response.data.suffix : response?.suffix,
                                            url: response?.data ? response.data.path : response?.path,
                                            path: response?.data ? response.data.path : response?.path,
                                            name: response?.data ? response.data.name : response?.name,
                                            md5: response?.data ? response.data.md5 : response?.md5,
                                            _id: response?.data ? response.data._id : response?._id,
                                        }
                                        this.setState({
                                            positionRecordOnline: temp,
                                        })
                                    } else {
                                        message.error(response?.message);
                                    }
                                }}
                                onError={(error) => {
                                    message.error(error);
                                }}
                                onRemove={(file) => {
                                    this.setState({positionRecordOnline: {}})
                                }}
                            />
                        </div>}
                        <style>{`
                        .edit_wrap .ant-upload.ant-upload-select-picture-card > .ant-upload{padding: 0;}
                        .edit_wrap .name_wrap{margin-bottom: 20px;}
                        `}</style>
                    </div>
                </CmForm>
            </Modal>
        );
    }
    /**
     * 复用阵地
     */
    rendCopyPosition(){
        let {logo,positionTypeList,editingMediaId} = this.state;
        return(
            <Modal
            title={'复用其他平台'}
            width={500}
            visible={this.state.copyVisible}
            onOk={()=>{this.reusePositionsOk()}}
            onCancel={() => this.setState({copyVisible: false})}
            centered={true}
            maskClosable={false}
        >
            <div>
                <div className="name_wrap" style={{marginBottom:'20px'}}>
                    <span >当前平台：</span>
                    <img style={{width: 25, height: 25, objectFit: "cover",marginRight:10}} src={logo} alt={""}/>
                    <span>{this.state.name}</span>
                </div>
                <div className="name_wrap" style={{marginBottom:'20px'}}> 
                    <span style={{color: "red"}}>*</span> 复用平台：
                     <Select    style={{ width: 200 }}     
                                value={this.state.currentType}  
                                onChange={value => {
                                    this.setState({currentType: value});
                                }}>
                                {positionTypeList&&positionTypeList.map((item)=>{
                                    return <Option key={item.id} value={item.id}><img style={{width: 20, height: 20, objectFit: "cover",marginRight:10}} src={item.logo} alt={""}/>{item.name}</Option>
                                })} 
                    </Select>
                </div>
                <div style={{color:'red'}}>确定后，将覆盖当前平台所有字段，请谨慎操作</div>
            </div>
        </Modal>
        )
    }
    reusePositionsOk(){
        this.request({
            url: "/cm-sites-media-consumer/system/positionField/copyField",
            method: "post",
            // contentType: "json",
            body:{
                sourceTypeId:this.state.currentType,
                typeId:this.state.editingMediaId,
            },
            callBack: (data) => {
                if(data) {
                    message.success("复用成功");
                    this.setState({copyVisible: false})
                }else {
                    message.warning("复用失败");
                }
            },
        });

    }
   

    getPositionType = () =>{
        this.request({
            url: "/cm-sites-media-consumer/system/positionType/getAllNoPage",
            method: "get",
            callBack: (data) => {
                let positionTypeList = [];
                let currentType= ''
                if (data && data.length) {
                    let newData = data.filter((item=>item.id !== this.state.editingMediaId))
                    positionTypeList = newData
                    currentType = positionTypeList[0].id
                }
                this.setState({positionTypeList,currentType})
            },
        });
        
    }

    copyPosition(record){  
        const {name, logo,id} = record;
        this.setState({
            copyVisible: true,
            logo,
            name,
            editingMediaId: id,
        },()=>{
            this.getPositionType()
        });
    }

    downTemplate(file) {
        let path = file.path;
        if (path.indexOf("?") === -1) {
            window.location.href = path + "?download=1";
        } else {
            window.location.href = path + "&download=1";
        }
    }

    electricFileType = ["xls","xlsx"];

    /**
     * 添加
     */
    add() {
        this.setState({
            addVisible: true,
            modalTitle: "新建平台",
            logo: "",
            name: "",
            builtIn: false,
            divisionName: "线上平台",
            contentEntry: 0,
            editingMediaId: "",
            disposeLink: "",
            positionRecordOnline: null
        });
        this.getSystemSetting();
    }

    getSystemSetting() {
        this.request({
            url: "/cm-sites-media-consumer/system/getCustomInfo",
            callBack: (response)=>{
                if (response) {
                    this.setState({
                        differentRecordOnline: response.differentRecordOnline,
                    })
                }
            }
        })
    }

    /**
     * 保存排序
     */
    saveSort() {
        this.request({
            url: '/cm-sites-media-consumer/system/positionType/saveAll',
            body: this.state.dataSource,
            method: "post",
            contentType: "json",
            callBack: (res) => {
                if (res) {
                    message.success("保存成功");
                    this.getList();
                } else {
                    message.warning("保存失败");
                }
            },
            errorCallBack: (e) => {
            },
        })
    }

    /**
     * 编辑
     */
    editPlatform(record) {
        const {name, logo, id, contentEntry, divisionName, disposeLink, positionRecordOnline} = record;
        this.setState({
            addVisible: true,
            modalTitle: "编辑平台",
            editingMediaId: id,
            logo,
            name,
            builtIn: true,
            contentEntry: contentEntry ? 1 : 0,
            divisionName,
            disposeLink,
            positionRecordOnline
        });
        this.getSystemSetting();
    }

    //保存  {创建 、 更新}
    handleOk(id) {
        const {
            logo,
            name,
            editingMediaId,
            builtIn,
            contentEntry,
            divisionName,
            disposeLink,
            positionRecordOnline
        } = this.state;
        if (name.trim() === "") {
            return message.warn("平台名称不能为空！");
        }
        if (name.length > 15) {
            message.warn("平台名称不能超过15个字");
            return;
        }
        const newMedia = {
            logo: logo,
            name: name,
            builtIn,
            contentEntry: !!contentEntry,
            divisionName,
            positionRecordOnline
        };
        if(editingMediaId) {
            newMedia.disposeLink = disposeLink;
        }
        if (!editingMediaId) {
            this.request({
                url: '/cm-sites-media-consumer/system/positionType/add',
                body: newMedia,
                method: "post",
                contentType: "json",
                callBack: (res) => {
                    // 创建成功的回调  还原数据 重新请求列表
                    message.success("添加成功");
                    this.getList();
                    this.setState({
                        addVisible: false
                    });
                },
                errorCallBack: (e) => {
                },
            })
        } else {
            //更新数据
            this.request({
                url: '/cm-sites-media-consumer/system/positionType/edit',
                body: {
                    id,
                    ...newMedia
                },
                method: "post",
                contentType: "json",
                callBack: (res) => {
                    // 编辑成功回调
                    message.success("修改成功");
                    this.getList();
                    this.setState({
                        addVisible: false
                    });
                },
                errorCallBack: (e) => {
                },
            })
        }
    }

    //删除
    delete(record) {
        this.request({
            url: '/cm-sites-media-consumer/system/positionType/delete',
            body: {positionTypeId: record.id},
            callBack: (res, status) => {
                if (status === 200) {
                    message.success("删除成功");
                    this.getList();
                } else {
                    message.warning("删除失败");
                }
            },
            errorCallBack: (e) => {
            },
        })
    }

    getList() {
        let params = {
            pageNum: this.state.pageNum,
            pageSize: this.state.pageSize
        };
        this.request({
            url: '/cm-sites-media-consumer/system/positionType/list',
            body: params,
            callBack: (res) => {
                let count = 0;
                let dataSource = [];
                if (res && res.data && res.data.length) {
                    dataSource = res.data;
                    count = res.count;
                }
                this.setState({
                    dataSource,
                    count
                });
            },
            errorCallBack: (e) => {
            },
        })
    }

    //维护字段
    maintenanceField(record) {
        let params = {
            id: record.id,
            name: record.name
        };
        setInfoToLocalStorage("MaintenanceField", params);
        window.location.hash = "/newMedia/maintenanceField/" + record.id;
    }

    viewFieldTable(record) {
        this.fieldsTable.viewFieldsTable(record);
    }

    renderScreen() {
        return (
            <div style={{height: this.searchHeight, lineHeight: this.searchHeight + "px"}}>
                <Button type="primary" onClick={() => this.add()}>添加</Button>
                <Button style={{marginLeft: 20}} onClick={() => this.saveSort()}>保存排序</Button>
            </div>
        )
    }

    // 表格行移动方法
    moveRow(dragIndex, hoverIndex) {
        const { dataSource } = this.state;
        const dragRow = dataSource[dragIndex];
        dragRow.order = hoverIndex;
        this.setState(update(this.state,{
            dataSource: {
                $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
                $apply: (arr)=>arr.map((item,index)=>{
                    return {
                        ...item,
                        order: index,
                    }
                })
            }
        }))
    }

    searchHeight = 54; // 搜索区高度
    tableHeaderHeight = 0; // 表头高度
    pageMargin = 15;  // 页面margin
    pagePadding = 0; // 页面padding
    tabsHeight = 0; // tab栏高度
    paginationHeight = 72; // 分页器高度
    topMenuHeight = 70; //顶部菜单高度
    otherHeight = this.searchHeight + this.tableHeaderHeight + this.pageMargin * 2 + this.pagePadding * 2 + this.tabsHeight + this.paginationHeight + this.topMenuHeight; // 除表格外的其他所有高度集合
    tableHeight = `calc(100vh - ${this.otherHeight + "px"})`;

    components = {
        body: {
            row: DragableBodyRow,
        }
    }

    render() {
        const columns = this.getColumns();
        const {tabKey = 'positionMaintenance', dataSource, pageNum, pageSize, count} = this.state;
        return (
            <PageTemplate>
                {this.renderScreen()}
                <Scrollbars autoHide autoHeight autoHeightMax={this.tableHeight}>
                    <DndProvider backend={HTML5Backend}>
                        <TableTemplate
                            key={"TableTemplate" + tabKey}
                            maxWidth={getMaxWidth(this.pageMargin * 2 + this.pagePadding * 2)}
                            maxHeight={this.tableHeight}
                            columns={columns}
                            dataSource={dataSource}
                            onResize={(offsetHeight) => {
                                if (this.tableHeaderHeight != offsetHeight) {
                                    this.tableHeaderHeight = offsetHeight;
                                    this.setState({});
                                }
                            }}
                            components={this.components}
                            onRow={(record,index)=>({
                                index,
                                moveRow: this.moveRow.bind(this)
                            })}
                        />
                    </DndProvider>
                </Scrollbars>
                <PaginationTemplate
                    key={"PageTemplate" + tabKey}
                    total={count || 0}
                    pageSize={pageSize || 10}
                    current={pageNum || 1}
                    dataSource={dataSource}
                    onShowSizeChange={this.onShowSizeChange}
                    onChange={this.onPageChange}
                    onResize={(offsetHeight) => {
                        if (this.paginationHeight != offsetHeight) {
                            this.paginationHeight = offsetHeight;
                            this.setState({});
                        }
                    }}
                />
                {this.renderAdd()}
                {/* 复用阵地 */}
                {this.rendCopyPosition()}
                <FieldsTable ref={ref => this.fieldsTable = ref}/>
            </PageTemplate>
        );
    }
}

function beforeUpload(file) {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
        message.warning("只能上传JPG/PNG文件！");
    }
    const isLt2M = file.size / 1024 / 1024 < 20;
    if (!isLt2M) {
        message.warning("图片大小必须小于20MB!");
    }
    return isJpgOrPng && isLt2M;
}